import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { OrdersPage } from '@/pages/orders/OrdersPage'
import { validateOrdersSearch } from '@/pages/orders/ordersSearch'

export const Route = createFileRoute('/orders')({
  // Фильтры списка живут в URL: переживают F5 и переносятся ссылкой.
  // Схема и значения по умолчанию — в pages/orders/ordersSearch.ts.
  validateSearch: validateOrdersSearch,
  component: () => (
    <RequirePermission section="orders" action="view">
      <OrdersPage />
    </RequirePermission>
  ),
})
